import React, { useEffect, useState, useRef } from "react";
import PropTypes from "kf-proptypes/widgets";
import { isArray } from "lodash-es";

import {
  DimensionInput,
  DIMENSION_INPUT_SIZE
} from "../elements/dimensioninput.jsx";
import {
  KfIcon,
  ICON_SIZE,
  KF_ICONS,
  ICON_STROKE
} from "../../common/components/primitives/kf_icon/index.jsx";
import { InheritDialog } from "../field/index.jsx";
import { ResetDialog } from "../../inputs/resetdialog/index.jsx";

import fieldstyles from "../field/style.css";
import styles from "./style.css";

const INITIAL_VALUES_ARRAY = ["0px", "0px", "0px", "0px"];

export function MultiDimensionProperty({
  label,
  value = "10px",
  units,
  onChange = () => {},
  onReset,
  modified,
  inheritedFrom,
  dimensions,
  showReset,
  showInherit,
  getPanelContainer
}) {
  const fieldRef = useRef();

  const [inputType, setInputType] = useState("four");
  const [commonValue, setCommonValue] = useState("0px");
  const [valuesArray, setValuesArray] = useState(INITIAL_VALUES_ARRAY);
  const arrayRef = useRef(INITIAL_VALUES_ARRAY);

  const onIndividualChange = (one, two, three, four) => {
    if (one === two && one === three && one === four) {
      onChange(one);
    } else {
      onChange([one, two, three, four]);
    }
  };

  useEffect(
    function loadValue() {
      if (isArray(value)) {
        setValueArr(value);
        setCommonValue("px");
      } else {
        setValueArr([value, value, value, value]);
        setCommonValue(value);
      }
    },
    [value]
  );

  useEffect(function inferInputType() {
    if (isArray(value)) {
      setInputType("four");
    } else {
      setInputType("one");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (value, index) => {
    let stateArr = arrayRef.current;
    stateArr[index] = value;
    setValueArr(stateArr);
    onIndividualChange(...stateArr);
  };

  function setValueArr(values) {
    setValuesArray([...values]);
    arrayRef.current = values;
  }

  return (
    <div className={styles.field} ref={fieldRef}>
      <div className={styles.top}>
        <label className={`tiny ${fieldstyles.label}`}>
          {label}
          {showInherit && !modified && (
            <InheritDialog
              inheritedFrom={inheritedFrom}
              getPanelContainer={getPanelContainer}
            />
          )}
          {showReset && modified && (
            <ResetDialog
              inheritedFrom={inheritedFrom}
              getPanelContainer={getPanelContainer}
              onReset={onReset}
            />
          )}
        </label>
        <div className={styles.onecontainer}>
          <button
            className={`${styles.switch} ${
              inputType === "one" ? styles.active : ""
            }`}
            onClick={() => setInputType("one")}
          >
            <KfIcon
              icon={KF_ICONS.PADDING}
              size={ICON_SIZE.SIZE_12}
              stroke={ICON_STROKE.THIN}
            />
          </button>
          <button
            className={`${styles.switch} ${
              inputType === "four" ? styles.active : ""
            }`}
            onClick={() => {
              setInputType("four");
            }}
          >
            <KfIcon
              icon={KF_ICONS.CORNERS_2}
              size={ICON_SIZE.SIZE_12}
              stroke={ICON_STROKE.THIN}
            />
          </button>
        </div>
        <DimensionInput
          size={DIMENSION_INPUT_SIZE.MEDIUM}
          units={units}
          value={commonValue}
          onChange={(value) => onIndividualChange(value, value, value, value)}
        />
      </div>
      {inputType === "four" && (
        <div className={styles.four}>
          <DimensionInput
            size={DIMENSION_INPUT_SIZE.MEDIUM}
            units={units}
            icon={dimensions[0].icon}
            title={dimensions[0].title}
            value={valuesArray[0]}
            onChange={(value) => handleChange(value, 0)}
          />
          <div />
          <DimensionInput
            size={DIMENSION_INPUT_SIZE.MEDIUM}
            icon={dimensions[1].icon}
            title={dimensions[1].title}
            units={units}
            value={valuesArray[1]}
            onChange={(value) => handleChange(value, 1)}
          />
          <DimensionInput
            size={DIMENSION_INPUT_SIZE.MEDIUM}
            icon={dimensions[2].icon}
            title={dimensions[2].title}
            units={units}
            value={valuesArray[2]}
            onChange={(value) => handleChange(value, 2)}
          />
          <div />
          <DimensionInput
            size={DIMENSION_INPUT_SIZE.MEDIUM}
            icon={dimensions[3].icon}
            title={dimensions[3].title}
            units={units}
            value={valuesArray[3]}
            onChange={(value) => handleChange(value, 3)}
          />
        </div>
      )}
    </div>
    // </PropertiesField>
  );
}

MultiDimensionProperty.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  units: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  onReset: PropTypes.func,
  modified: PropTypes.bool,
  showInherit: PropTypes.bool,
  showReset: PropTypes.bool,
  getPanelContainer: PropTypes.func,
  dimensions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      icon: PropTypes.node
    })
  ),
  inheritedFrom: PropTypes.string
};
